// enums.ts

export enum ExportStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	PROCESSED = 'PROCESSED',
	FAILED = 'FAILED',
}

export enum LocationType {
	HUB = 'HUB',
	WAREHOUSE = 'WAREHOUSE',
	OFFICE = 'OFFICE',
	RESIDENCE = 'RESIDENCE',
	PORT = 'PORT',
	AIRPORT = 'AIRPORT',
}

export enum OffsetPolicy {
	NEVER = 'NEVER',
	ALWAYS = 'ALWAYS',
	ON_DEMAND = 'ON_DEMAND',
}

export enum CreationMethod {
	MANUAL = 'MANUAL',
	SCRIPT = 'SCRIPT',
	FILE = 'FILE',
	API = 'API',
}

export enum UserRole {
	USER = 'USER',
	STAFF = 'STAFF',
	ADMIN = 'ADMIN',
	SUPERADMIN = 'SUPERADMIN',
}

export enum TokenType {
	AUTH = 'AUTH',
	API = 'API',
}

export enum ProductionUnit {
	KWH = 'KWH',
	KG = 'KG',
}

export enum ProjectType {
	MEASURABILITY = 'Measurability',
	ADDITIONALITY = 'Additionality',
}

export enum EntityType {
	BRAND = 'Brand',
	PRODUCER = 'Producer',
	TRANSPORTER = 'Transporter',
}

export enum MediaDisc {
	PRIVATE = 'PrivateMedia',
	PUBLIC = 'PublicMedia',
}

export enum Languages {
	EN = 'en',
	FR = 'fr',
}

export enum ProductionQuantityCheck {
	OK = 'OK',
	UNDER_RANGE = 'UNDER_RANGE',
	OVER_RANGE = 'OVER_RANGE',
}

export enum ExportType {
	PRODUCTION_LIST = 'PRODUCTION_LIST',
}

export enum ImportType {
	PRODUCTIONS = 'PRODUCTIONS',
}

export enum Blockchain {
	POLYGON_MUMBAI = 'POLYGON_MUMBAI',
	GNOSIS_CHIADO = 'GNOSIS_CHIADO',
}

export enum QueueStatus {
	PENDING = 'PENDING',
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	BYPASSED = 'BYPASSED',
}

export enum ProjectTechnology {
	THERMAL_SOLAR = 'THERMAL_SOLAR',
	PHOTOVOLTAIC = 'PHOTOVOLTAIC',
	WIND = 'WIND',
	BIOMASS = 'BIOMASS',
	HEAT_PUMP = 'HEAT_PUMP',
	FATAL_HEAT = 'FATAL_HEAT',
	LOW_CARBON_MATERIAL = 'LOW_CARBON_MATERIAL',
	UNSPECIFIED = 'UNSPECIFIED',
}

export enum Aco2OpsStatus {
	HELD = 'HELD',
	BURNT = 'BURNT',
}

export enum AddiOpsStatus {
	HELD = 'HELD',
	STACKED = 'STACKED',
	UNSTACKED = 'UNSTACKED',
	BURNT = 'BURNT',
}

export enum ProductionStatus {
	AVAILABLE = 'AVAILABLE',
	LOCKED = 'LOCKED',
	MINTED = 'MINTED',
}

export enum MediaType {
	FILE = 'FILE',
	IMAGE = 'IMAGE',
	VIDEO = 'VIDEO',
	AUDIO = 'AUDIO',
}

export enum ImportStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	ROLLED_BACK = 'ROLLED_BACK',
}

export const ModelsWithPrivateMedia: readonly string[] =
	Object.freeze([
		'Additionality',
		'Measurability',
		'Certificate',
	]);

export const PrivateBuckets: readonly string[] =
	Object.freeze(['private', 'certificates']);

export const PublicBuckets: readonly string[] =
	Object.freeze(['statics']);

export enum DrawerPositions {
	TOP = 'top',
	RIGHT = 'right',
	LEFT = 'left',
	BOTTOM = 'bottom',
}
